import axios from "axios";

import authentication from './authentication';

let instance = axios.create({
    // baseURL: 'http://localhost:5000',
    responseType: 'json',
    withCredentials: true,
});

// instance.interceptors.request.use(function (config) {
//     if(config.method === 'post') {
//         let _Authorization = authentication.getCredentials();
//         config.headers.Authorization = _Authorization;
//     }

//     return config;
//   }, function (error) {
//     // Do something with request error
//     return Promise.reject(error);
// });

// instance.interceptors.request.use(
//     (config) => {
//         const token = document.cookie.replace(/(?:(?:^|.*;\s*)session_token\s*=\s*([^;]*).*$)|^.*$/, '$1');
//         if (token) {
//             config.headers.Authorization = `Bearer ${token}`;
//         }
//         return config;
//     },
//     (error) => {
//         return Promise.reject(error);
//     }
// );

export default instance;